<template>
  <v-app id="inspire">
    <v-navigation-drawer
      color="blue darken-4"
      v-model="drawer"
      app
      :mini-variant="mini"
      width="250"
      mini-variant-width="84"
      mobile-break-point="900"
      :clipped="true"
    >
      <v-list class="pt-5 overflow-y-auto" dense nav dark style="height: 100%;">
        <template v-for="(item, i) in items">
          <!------------------------------------------------->
          <!-- SIMPLE ITEM ---------------------------------->
          <!------------------------------------------------->
          <template v-if="!item.items">
            <v-list-item v-if="item.show" :key="i" :to="item.to">
              <v-list-item-icon>
                <v-icon v-if="item.icon">
                  {{ item.icon }}
                </v-icon>
                <v-img
                  v-else
                  :src="require(`${item.img}.png`)"
                  aspect-ratio="1"
                  max-width="20"
                  contain
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="item.pointer">
                <v-icon color="grey lighten-1" small>
                  fiber_manual_record
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
          <!------------------------------------------------->
          <!-- GROUP ITEMS ---------------------------------->
          <!------------------------------------------------->
          <template v-else>
            <v-list-group
              v-if="item.show"
              :key="i"
              no-action
              active-class="white--text"
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon v-if="item.icon">
                    {{ item.icon }}
                  </v-icon>
                  <v-img
                    v-else
                    :src="require(`${item.img}.png`)"
                    aspect-ratio="1"
                    max-width="20"
                    contain
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <template v-for="(subitem, j) in item.items">
                <v-list-item
                  v-if="subitem.show"
                  :key="j"
                  :to="subitem.to"
                  active-class="white--text"
                >
                  <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="white" :clipped-left="true" app class="pr-0">
      <v-app-bar-nav-icon
        color="primary"
        class="ml-1"
        @click.stop="mini = !mini"
      ></v-app-bar-nav-icon>
      <v-divider vertical class="mx-4"></v-divider>
      <v-toolbar-title>
        <span class="hidden-sm-and-down">
          <img
            src="@/assets/afrus_logo_2.png"
            class="afrus-drawer-logo"
            alt="afrus"
          />
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-menu
          transition="slide-y-transition"
          offset-y
          right
          nudge-bottom="10"
          style="z-index: 100;"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
              <div class="afrus-profile-user">
                <strong v-if="user">
                  {{ name }}
                </strong>
              </div>
              <v-avatar color="#02579b" size="40" class="ml-4">
                <span class="white--text subheading">
                  {{ siglas }}
                </span>
              </v-avatar>
            </v-btn>
          </template>
          <v-card min-width="250">
            <v-list v-if="user" dense>
              <v-list-item>
                <v-list-item-avatar size="40" color="primary" class="mr-4">
                  <span class="subheading white--text">{{ siglas }}</span>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-uppercase">
                    {{ name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider />
            <v-list>
              <v-list-item to="/account/profile">
                <v-list-item-icon class="ml-2 mr-5 my-3">
                  <v-icon color="primary">
                    person_outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="ml-1">
                  {{ $t("general.profile") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout()">
                <v-list-item-icon class="ml-2 mr-5 my-3">
                  <v-icon color="primary">
                    exit_to_app
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="ml-1">
                  {{ $t("general.logout") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-container v-else class="py-8">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  async created() {
    this.isLoading = true;
    await this.getProfile();
    this.isLoading = false;
  },
  data() {
    return {
      isLoading: false,
      dialog: false,
      drawer: null,
      mini: false,
      siglas: "",
      name: "",
      items: [
        {
          icon: "cached",
          text: this.$t("recurring_debit.title"),
          to: "/payments",
          show: true
        },
        {
          icon: "payment",
          text: this.$t("transactions.title"),
          show: true,
          items: [
            {
              text: this.$t("transactions.title"),
              to: "/transactions/index",
              show: true
            },
            {
              text: this.$t("transactions.uniques"),
              to: "/transactions/uniques",
              show: true
            },
            {
              text: this.$t("transactions.title2"),
              to: "/transactions/subscriptions",
              show: true
            },
            {
              text: this.$t("transactions.charges"),
              to: "/transactions/charges",
              show: true
            },
            {
              text: this.$t("transactions.title4"),
              to: "/transactions/failed",
              show: true
            }
          ]
        },
        {
          icon: "groups",
          text: this.$t("leads.title"),
          to: "/leads",
          show: true
        },
        {
          icon: "arrow_downward",
          text: this.$t("transactions.dashboard.export"),
          to: "/downloads",
          show: true
        }
      ]
    };
  },
  watch: {
    user(newVal, oldVal) {
      this.siglas = `${newVal.first_name[0]}${newVal.last_name[0]}`;
      this.name = `${newVal.first_name} ${newVal.last_name}`;
    }
  },
  methods: {
    ...mapActions({
      getProfile: "auth/getProfile"
    }),
    ...mapMutations({
      resetLanguaje: "auth/resetLanguaje"
    }),
    logout() {
      this.$auth.destroyToken();
      this.resetLanguaje();
      this.$router.push({ name: "login" });
    }
  },
  computed: {
    ...mapState({
      user: ({ auth: { user } }) => user
    })
  }
};
</script>
